import { useSetAtom } from 'jotai';
import AsyncButton from '@wojtekmaj/react-async-button';
import T, { useTranslation } from '@wojtekmaj/react-t';

import { toast } from '@rewardopl/react-toast';

import Button from '@rewardopl/react-ui/button';

import { get, post } from '@rewardopl/utils/network';

import { vendorCardCouponActivationsQuery } from '../../../../../../../store';

import type { CouponActivation, CouponWithDynamicProperties } from '@rewardopl/types';

const pendingConfig = {
  disabled: true,
};

type ActivateButtonProps = {
  coupon: CouponWithDynamicProperties;
  disabled?: boolean;
  setCoupon: (coupon: CouponWithDynamicProperties) => void;
};

export default function ActivateButton({ coupon, disabled, setCoupon }: ActivateButtonProps) {
  const activateErrorString = useTranslation('Failed to activate the coupon');
  const deactivateErrorString = useTranslation('Failed to deactivate the coupon');

  const { _id: couponId, card_id: cardId, is_activated: isActivated, is_hidden: isHidden } = coupon;

  const setCouponActivations = useSetAtom(vendorCardCouponActivationsQuery(couponId));

  if (isActivated && isHidden) {
    return null;
  }

  const action = `/api/cards/${cardId}/coupons/${couponId}/${
    isActivated ? 'deactivate' : 'activate'
  }`;

  const errorString = isActivated ? deactivateErrorString : activateErrorString;

  async function onClick(event: React.MouseEvent<HTMLButtonElement>) {
    event.preventDefault();

    try {
      await post(action);

      const nextCouponActivations = (await get(
        `/api/cards/${cardId}/coupons/${couponId}/coupon_activations`,
      )) as CouponActivation[];

      setCoupon({ ...coupon, is_activated: !isActivated });

      setCouponActivations(nextCouponActivations);
    } catch {
      toast.error(errorString);
    }
  }

  return (
    <AsyncButton
      as={Button}
      className="primary"
      disabled={disabled}
      onClick={onClick}
      pendingConfig={pendingConfig}
      type="button"
    >
      <T>{isActivated ? 'Deactivate' : 'Activate'}</T>
    </AsyncButton>
  );
}
